<!-- cv简历信息表-标准化考试成绩- 后期可以考虑优化-->
<template>
  <div class='detail-wrap-score'>
    <div class='detail-container'>
      <div class='cv-detail en'>
        <div class='table-container'>
          <h4>TOEFL</h4>
          <div class='sample-table'>
            <div class='table-header'>
              <ul>
                <li>Testing Date</li>
                <li>Total Score</li>
                <li>Reading</li>
                <li>Listening</li>
                <li>Speaking</li>
                <li>Writing</li>
              </ul>
            </div>
            <div class='table-body-wrap'
                 v-if='scoreDetailEn.toeflReports && scoreDetailEn.toeflReports.length > 0'>
              <div class='table-body'
                   v-for='(item, index) in scoreDetailEn.toeflReports'
                   :key='index'>
                <ul>
                  <li>{{item.time}}</li>
                  <li>{{item.score}}</li>
                  <li>{{item.reading}}</li>
                  <li>{{item.listening}}</li>
                  <li>{{item.speaking}}</li>
                  <li>{{item.writing}}</li>
                </ul>
              </div>
            </div>
            <div class='table-body'
                 v-else>
              <ul>
                <li>No Data</li>
              </ul>
            </div>
          </div>
        </div>
        <div class='table-container'>
          <h4>IELTS</h4>
          <div class='sample-table'>
            <div class='table-header'>
              <ul>
                <li>Testing Date</li>
                <li>Total Score</li>
                <li>Reading</li>
                <li>Listening</li>
                <li>Speaking</li>
                <li>Writing</li>
              </ul>
            </div>
            <div class='table-body-wrap'
                 v-if='scoreDetailEn.ieltsReports && scoreDetailEn.ieltsReports.length > 0'>
              <div class='table-body'
                   v-for='(item, index) in scoreDetailEn.ieltsReports'
                   :key='index'>
                <ul>
                  <li>{{item.time}}</li>
                  <li>{{item.score}}</li>
                  <li>{{item.reading}}</li>
                  <li>{{item.listening}}</li>
                  <li>{{item.speaking}}</li>
                  <li>{{item.writing}}</li>
                </ul>
              </div>
            </div>
            <div class='table-body'
                 v-else>
              <ul>
                <li>No Data</li>
              </ul>
            </div>
          </div>
        </div>
        <div class='table-container'>
          <h4>SAT</h4>
          <div class='sample-table'>
            <div class='table-header'>
              <ul>
                <li>Testing Date</li>
                <li>Total Score</li>
                <li>Reading</li>
                <li>Math</li>
                <li>Writing</li>
              </ul>
            </div>
            <div class='table-body-wrap'
                 v-if='scoreDetailEn.satReports && scoreDetailEn.satReports.length > 0'>
              <div class='table-body'
                   v-for='(item, index) in scoreDetailEn.satReports'
                   :key='index'>
                <ul>
                  <li>{{item.time}}</li>
                  <li>{{item.score}}</li>
                  <li>{{item.reading}}</li>
                  <li>{{item.math}}</li>
                  <li>{{item.writing}}</li>
                </ul>
              </div>
            </div>
            <div class='table-body'
                 v-else>
              <ul>
                <li>No Data</li>
              </ul>
            </div>
          </div>
        </div>
        <div class='table-container'>
          <h4>SAT2</h4>
          <div class='sample-table'>
            <div class='table-header'>
              <ul>
                <li>Testing Date</li>
                <li>Score</li>
                <li>Subject</li>
              </ul>
            </div>
            <div class='table-body-wrap'
                 v-if='scoreDetailEn.sat2Reports && scoreDetailEn.sat2Reports.length > 0'>
              <div class='table-body'
                   v-for='(item, index) in scoreDetailEn.sat2Reports'
                   :key='index'>
                <ul>
                  <li>{{item.time}}</li>
                  <li>{{item.score}}</li>
                  <li>{{item.subject}}</li>
                </ul>
              </div>
            </div>
            <div class='table-body'
                 v-else>
              <ul>
                <li>No Data</li>
              </ul>
            </div>
          </div>
        </div>
        <div class='table-container'>
          <h4>ACT</h4>
          <div class='sample-table'>
            <div class='table-header'>
              <ul>
                <li>Testing Date</li>
                <li>Total Score</li>
                <li>English</li>
                <li>Math</li>
                <li>Reading</li>
                <li>Science</li>
                <li>Writing</li>
              </ul>
            </div>
            <div class='table-body-wrap'
                 v-if='scoreDetailEn.actReports && scoreDetailEn.actReports.length > 0'>
              <div class='table-body'
                   v-for='(item, index) in scoreDetailEn.actReports'
                   :key='index'>
                <ul>
                  <li>{{item.time}}</li>
                  <li>{{item.score}}</li>
                  <li>{{item.english}}</li>
                  <li>{{item.math}}</li>
                  <li>{{item.reading}}</li>
                  <li>{{item.science}}</li>
                  <li>{{item.writing}}</li>
                </ul>
              </div>
            </div>
            <div class='table-body'
                 v-else>
              <ul>
                <li>No Data</li>
              </ul>
            </div>
          </div>
        </div>
        <div class='table-container'>
          <h4>AP</h4>
          <div class='sample-table'>
            <div class='table-header'>
              <ul>
                <li>Testing Date</li>
                <li>Score</li>
                <li>Subject</li>
              </ul>
            </div>
            <div class='table-body-wrap'
                 v-if='scoreDetailEn.apReports && scoreDetailEn.apReports.length > 0'>
              <div class='table-body'
                   v-for='(item, index) in scoreDetailEn.apReports'
                   :key='index'>
                <ul>
                  <li>{{item.time}}</li>
                  <li>{{item.score}}</li>
                  <li>{{item.subject}}</li>
                </ul>
              </div>
            </div>
            <div class='table-body'
                 v-else>
              <ul>
                <li>No Data</li>
              </ul>
            </div>
          </div>
        </div>
        <div class='other-test'>
          <h4>Additional Information</h4>
          <div class='other-con'>
            <div class='other-con-name'>Other testing information</div>
            <div class='other-con-val'>{{scoreDetailEn.otherNotes}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 学员num
      menteeNum: '',
      // 标准化考试成绩详情
      scoreDetailEn: {}
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    this.getScoreDetailEn()
  },
  methods: {
    // 获取标准化考试成绩-en
    getScoreDetailEn () {
      cvService.cvScoreDetailEn({ num: this.menteeNum }).then(res => {
        if (res.data.model) {
          this.scoreDetailEn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
.detail-wrap-score {
  padding-top: 10px;
  padding-bottom: 10px;
  .detail-container {
    background: #fff;
    display: flex;
    .cv-detail {
      flex: 1;
      padding: 20px 60px;
      .table-container {
        .sample-table {
          border: 1px solid #e6eaf1;
          border-radius: 8px;
          border-radius: 8px;
          .table-header {
            height: 48px;
            background: #f6f8fa;
            border-bottom: 1px solid #e6eaf1;
            ul {
              display: flex;
              align-items: center;
              li {
                flex: 1;
                font-size: 14px;
                line-height: 48px;
                color: #667483;
                letter-spacing: 0;
                text-align: center;
              }
            }
          }
          .table-body {
            ul {
              height: 48px;
              border-bottom: 1px solid #e6eaf1;
              display: flex;
              li {
                flex: 1;
                font-size: 14px;
                line-height: 48px;
                color: #323c47;
                letter-spacing: 0;
                text-align: center;
              }
            }
          }
        }
      }
      .other-test {
        .other-con {
          display: flex;
          .other-con-name {
            flex: 0 0 200px;
          }
          .other-con-val {
            flex: 1;
          }
        }
      }
    }
    .cv-form {
      flex: 1;
      padding: 20px 0;
    }
    .cv-btn {
      flex: 0 0 160px;
      text-align: right;
      a {
        display: inline-block;
        width: 96px;
        height: 32px;
        background: rgb(224, 235, 254);
        border-radius: 8px;
        border-radius: 8px;
        font-size: 14px;
        color: #186ffa;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
        margin: 10px 10px 0 10px;
      }
    }
  }
  h4 {
    font-size: 18px;
    color: #4aa6ff;
    letter-spacing: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .oper-add {
    text-align: right;
    a {
      display: inline-block;
      width: 96px;
      height: 32px;
      background: rgb(224, 235, 254);
      border-radius: 8px;
      border-radius: 8px;
      font-size: 14px;
      color: #186ffa;
      letter-spacing: 0;
      text-align: center;
      line-height: 32px;
      margin-bottom: 20px;
    }
  }
  .oper-del {
    text-align: right;
    a {
      display: inline-block;
      width: 96px;
      height: 32px;
      background: rgb(224, 235, 254);
      border-radius: 8px;
      border-radius: 8px;
      font-size: 14px;
      color: #186ffa;
      letter-spacing: 0;
      text-align: center;
      line-height: 32px;
      margin-bottom: 20px;
    }
  }
  .sub-btn {
    text-align: right;
    button {
      display: inline-block;
      width: 100px;
      height: 36px;
      background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
      border-radius: 8px;
      border-radius: 8px;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
    }
    // a {
    //   display: inline-block;
    //   width: 100px;
    //   height: 36px;
    //   background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
    //   border-radius: 8px;
    //   border-radius: 8px;
    //   font-size: 18px;
    //   color: #ffffff;
    //   letter-spacing: 0;
    //   text-align: center;
    //   line-height: 36px;
    // }
  }
  .pad-top {
    padding-top: 20px;
  }
  .pad-left {
    padding-left: 60px;
  }
}
</style>
